var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormConfirm.jinja');
require('./SubmissionFormConfirm.less');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'click .SubmissionFormElement-checkboxLabel a': 'onRulesClick'
    },

    initialize: function (options) {
        this.options = options || {};

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    onRulesClick: function (e) {
        e.stopPropagation(); //to prevent click on label action: checkbox toggle
    },


    checkRequired: function () {
        var $checkbox = this.$('.SubmissionFormElement-checkbox');
        var $label = this.$('.SubmissionFormElement-checkboxLabel');

        if (!$checkbox.is(':checked')) {

            $label.addClass('SubmissionFormElement-checkboxLabel--error');

            $checkbox.one('change', function () {
                $label.removeClass('SubmissionFormElement-checkboxLabel--error');
            });

            app.animateWindowScroll(this.$el.offset().top - 80);

            return false;
        }

        return true;
    },


    getFormData: function () {
        return {};
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormConfirm.js
// module id = 112
// module chunks = 0